export default __webpack_public_path__ + "static/media/detail_main_img_4.e71a4ac3.png";